import { PROPOSAL_RIDERS_LIST } from "../../constant/gms-constant";
import { ProposalRidersList } from "../../features/gms-proposal-forms/attachable-rider/attachable-riders.state";

export const getProposalRiders = (excludedIds: number[] = [] ): ProposalRidersList[] => {
    return PROPOSAL_RIDERS_LIST.filter(
        rider => !excludedIds.includes(rider.id)
    );
};

export const getProposalRidersByOrder = ( orderedIds: number[] ): ProposalRidersList[] => {
    return orderedIds
        .map(id => PROPOSAL_RIDERS_LIST.find(rider => rider.id === id))
        .filter((rider): rider is ProposalRidersList => rider !== undefined);
};